import { combineReducers } from "redux";
import OrderReducer from "./Orders/OrderReducer";
import CouponReducer from "./Coupons/CouponReducer";
import ServiceReducer from "./Services/ServiceReducer";
import ProductReducer from "./Products/ProductReducer";
import VariantReducer from "./Variants/VariantReducer";
import ReturnReducer from "./Returns/ReturnReducer";
import UserReducer from "./Auth/UserReducer";
import CategoryReducer from "./Categories/CategoryReducer";
import CountryReducer from "./Country/CountryReducer";
import UsersReducer from "./Users/UsersReducer";
import BrandReducer from "./Brands/BrandReducer";
import StoreReducer from "./Store/StoreReducer";
import CreateStoreReducer from "./CreateStore/CreateStoreReducer";
import PageStateReducer from "./PageState/PageStateReducer";
import DisputeReducer from "./Disputes/DisputeReducer";
import BannerReducer from "./Banners/BannerReducer";
import NotFound from "./NotFound/NotFoundReducer.js";
import LayoutReducer from "./Layout/LayoutReducer";

export default combineReducers({
  layout: LayoutReducer,
  order: OrderReducer,
  coupon: CouponReducer,
  service: ServiceReducer,
  product: ProductReducer,
  variant: VariantReducer,
  return: ReturnReducer,
  auth: UserReducer,
  category: CategoryReducer,
  country: CountryReducer,
  user: UsersReducer,
  brand: BrandReducer,
  banner: BannerReducer,
  vendorStore: StoreReducer,
  store: CreateStoreReducer,
  pageState: PageStateReducer,
  dispute: DisputeReducer,
  notFound: NotFound,
});
